import { render, staticRenderFns } from "./chooseCreateType.vue?vue&type=template&id=7f34a398&scoped=true"
import script from "./chooseCreateType.vue?vue&type=script&lang=js"
export * from "./chooseCreateType.vue?vue&type=script&lang=js"
import style0 from "./chooseCreateType.vue?vue&type=style&index=0&id=7f34a398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f34a398",
  null
  
)

export default component.exports